import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { change as changeFormValue, Field, getFormValues } from "redux-form";
import { ReduxControls } from 'rhombus-react';
import { required } from "forms/validators/validators";
import { allErrorsSelector } from "forms/validators/Social";

const loadingOption = { name: 'Loading...', isDisabled: true };

const Select = (props) => {
	const {
		formName,
		shouldLoadOptions,
		dependenciesMap,
		loadFn,
		responseProp,
		...fieldProps
	} = props;
	const values = useSelector(getFormValues(formName));
	const messages = useSelector(allErrorsSelector(formName));
	const dispatch = useDispatch();

	const [options, setOptions] = useState(undefined);
	const [page, setPage] = useState(0);
	const [totalPages, setTotalPages] = useState(1);
	const [isLoading, setIsLoading] = useState(false);

	const loadOptions = (nextPage) => {
		setIsLoading(true);
		setOptions((opts) => {
			return (opts === undefined) ? undefined : [...opts, loadingOption];
		});
		const params = Object.keys(dependenciesMap).reduce((acc, key) => {
			if (values[key]?.value) {
				acc[dependenciesMap[key]] = values[key].value;
			}
			return acc;
		}, {});
		params.page = nextPage;
		dispatch(loadFn(params)).then((resp) => {
			const data = resp.payload?.data;
			if (resp.success && data) {
				setOptions((opts) => {
					return (opts === undefined) ? data[responseProp] : [...opts.slice(0, -1), ...data[responseProp]];
				});
				setPage(nextPage);
				setTotalPages(data.totalPages);
				setIsLoading(false);
			}
		});
	};

	const deps = [...Object.keys(dependenciesMap).map(key => values[key].value), shouldLoadOptions];
	useEffect(() => {
		if (shouldLoadOptions) {
			setOptions(undefined);
			loadOptions(1);
		}
	}, deps);

	useEffect(() => {
		const value = values[fieldProps.name]?.value;
		if (options && value && !options.find(opt => opt.alias === value.alias)) {
			dispatch(changeFormValue(formName, fieldProps.name, undefined));
		}
	}, [options]);

	const onMenuScrollToBottom = () => {
		if (shouldLoadOptions && !isLoading && (page < totalPages)) {
			loadOptions(page + 1);
		}
	};

	return (
		<Field
			{...fieldProps}
			required
			component={ReduxControls.Select}
			options={(options || []).map(v => ({ value: v, label: v.name, isDisabled: v.isDisabled || false }))}
			className={messages.length ? "error" : ""}
			validate={[required]}
			isSearchable={false}
			isClearable={false}
			disabled={options === undefined}
			onMenuScrollToBottom={onMenuScrollToBottom}
		/>
	);
};

export default Select;
